import { render, staticRenderFns } from "./articles.vue?vue&type=template&id=333590d3&scoped=true&"
import script from "./articles.vue?vue&type=script&lang=js&"
export * from "./articles.vue?vue&type=script&lang=js&"
import style0 from "./articles.vue?vue&type=style&index=0&id=333590d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333590d3",
  null
  
)

export default component.exports